var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerminated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "3 3 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3C13.866 3 17 6.134 17 10C17 13.866 13.866 17 10 17C6.134 17 3 13.866 3 10C3.00004 6.13402 6.13402 3.00004 10 3ZM6.84082 9.25C6.42716 9.25017 6.09082 9.5863 6.09082 10C6.09082 10.4137 6.42716 10.7498 6.84082 10.75H13.2061C13.6197 10.7498 13.9561 10.4137 13.9561 10C13.9561 9.5863 13.6197 9.25017 13.2061 9.25H6.84082Z",
    fill: "#E4001C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminated);
export default __webpack_public_path__ + "static/media/terminated.015891f116e72d76af4dd700432bd997.svg";
export { ForwardRef as ReactComponent };